import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import { approveRecipeComment } from "../../../store/actions";
import { FormField } from "../../../sharedComponents/formField";
import { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { required } from "../../../constants/formValidators";

const EditCommentPanel = ({ handleSubmit, resetForm, toggle, onUpdate, approveRecipeComment }) => {
	const [submitting, setSubmitting] = useState(false);
	const validateForm = (values) => {
		setSubmitting(true);
		const successHandler = () => {
			NotificationManager.success("Comment updated.", "", 5000);
			onUpdate();
			toggle();
			setSubmitting(false);
		};
		approveRecipeComment({ ...values, is_approved: 1 }, successHandler);
	};

	const resetNow = () => {
		resetForm("EditCommentForm");
		toggle();
	};

	return (
		<form className="advanced-filter-form flex-fill d-flex flex-column" onSubmit={handleSubmit(validateForm)}>
			<PanelBody>
				<div className="row">
					<Field
						label="Title"
						name="title"
						type="text"
						formGroupClass="col-12"
						component={FormField}
						validate={[required]}
					/>
				</div>
				<div className="row">
					<Field
						label="Notes"
						name="notes"
						type="textarea"
						formGroupClass="col-12"
						component={FormField}
						validate={[required]}
					/>
				</div>
			</PanelBody>
			<PanelFooter className="pt-0 pb-1">
				<div className="text-right pt-3 pb-3">
					<button className="btn btn-default" type="button" onClick={resetNow}>
						Cancel
					</button>
					<button className="btn btn-primary-dark text-uppercase" type="submit" disabled={submitting}>
						Submit
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapDispatchToProps = {
	resetForm: reset,
	approveRecipeComment
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "EditCommentForm"
	})(EditCommentPanel)
);
